module.exports = __webpack_public_path__ + "img/vertical_3_1_7005.85443406.png";